import { useState, useEffect } from "react";
import app from "../../api/firebaseConf";
import { collection, getFirestore, getDocs, deleteDoc, doc, query, where } from "firebase/firestore";
import {PencilAltIcon, TrashIcon, PlusCircleIcon } from "@heroicons/react/solid"
import { toast } from "react-toastify";
import FormRooms from "./FormRooms";
import FormDevices from "./FormDevices";

export default function Settings(){

    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [refresh,setRefresh] = useState(false)
    
    const [table, setTable] = useState([])
    const [tbroom, setTbroom] = useState([])
    const [selector,setSelector] = useState([])

    //nuevo para editar el campo
    const [currentId,setCurrentId] = useState('')

    const handleClose = () => {
        setModal(false)
        setModal2(false)
        setRefresh(!refresh)
        //nuevo para editar el campo
        
    }

    const db = getFirestore(app)
    useEffect(()=>{
        const obtenerDatos =  async()=>{
          const datos = await getDocs(collection(db,'sensores'));
          const datos_h = await getDocs(collection(db,'habitaciones'));
          const devices = [];
          const rooms = []

          const countdevices = {}

          
          datos_h.forEach(doc => {
            rooms.push({...doc.data(), id:doc.id})
            countdevices[doc.data().nombre] = 0
          })

          datos.forEach((doc) => {
            devices.push({...doc.data(), id:doc.id})
            countdevices[doc.data().habitacion] +=1

          })

          // se recorre el arreglo y se vuelve a rellenar con el valor de dispositivos en la sala
          rooms.forEach((e,i) => {
            rooms[i]['parametro'] = countdevices[e.nombre]

          })

          //console.log(rooms)

          setTable(devices)
          setTbroom(rooms)

          const array = []
          const q = query(collection(db, 'habitaciones'), where("nombre",  "!=", ""))
          const querysnap = await getDocs(q)
          querysnap.forEach((doc) => {
              //console.log(doc.id, " => ", doc.data());
              array.push(doc.data().nombre)
            }
            );
            setSelector(array)
            
        }
        obtenerDatos()
        

      },[refresh])

    const onDelete = async(id, coleccion ) => {
        if (window.confirm("Estas seguro de eliminar este item? ")){
            console.log('delete: '+id)
            await deleteDoc(doc(db, coleccion,id))
            toast('Item eliminado exitosamente', {
                type: 'info'
            })
            setRefresh(!refresh)
        }
    }

    return(
        <div className='pt-14 sm:pt-0'>
            <h1 className="text-3xl font-press-start font-bold uppercase mb-4 sm:mb-8">Configuración</h1>
            <div>
                <div className="flex justify-between">
                <h1 className="text-2xl font-press-start font-semibold mb-4 sm:mb-8">Habitaciones</h1>
                
                <PlusCircleIcon className="w-10 h-10 fill-slate-600 cursor-pointer hover:fill-slate-500" onClick={()=>{setModal(true); setCurrentId('')}}/>
                </div>
                
                <div className="relative overflow-x-auto shadow-md rounded-2xl">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs uppercase bg-gray-800 text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">Nombre</th>
                                <th scope="col" className="px-6 py-3"># Dipositivos</th>
                                <th scope="col" className="px-6 py-3">Topico</th>
                                <th scope="col" className="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {tbroom.map((data,index) => (
                                <tr key={data.id}>
                                    <td className="px-6 py-3">{data.nombre}</td>
                                    <td className="px-6 py-3">{data.parametro}</td>                                    
                                    <td className="px-6 py-3">{data.topico}</td>
                                    <td className="px-6 py-3" id={data.id}>
                                        <div className="flex space-x-4">
                                            <PencilAltIcon className="h-5 w-5 fill-blue-500 cursor-pointer" aria-hidden="true" onClick={()=>{setCurrentId(data.id); setModal(true)}}/>
                                            <TrashIcon className="h-5 w-5 fill-red-600 cursor-pointer" aria-hidden="true" onClick={()=>onDelete(data.id,'habitaciones')} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <FormRooms open={modal} close={handleClose} id = {currentId} />
                </div>

                <div className="flex justify-between pt-8">
                <h1 className="text-2xl font-press-start font-semibold mb-4 sm:mb-8">Dispositivos</h1>

                <PlusCircleIcon className="w-10 h-10 fill-slate-600 cursor-pointer hover:fill-slate-500" onClick={()=>{setModal2(true);setCurrentId('')}}/>
                </div>
                <FormDevices open={modal2} close={handleClose} seleccion={selector} id = {currentId}/>
                <div className="relative overflow-x-auto shadow-md rounded-2xl">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs uppercase bg-gray-800 text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">Sensor</th>
                                <th scope="col" className="px-6 py-3">Grafica</th>
                                <th scope="col" className="px-6 py-3">Color</th>
                                <th scope="col" className="px-6 py-3">Variable</th>
                                <th scope="col" className="px-6 py-3">Ubicacion</th>
                                <th scope="col" className="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                        { table.map((data) => (
                                <tr key={data.id}>
                                    <td className="px-6 py-3">{data.nombre}</td>
                                    <td className="px-6 py-3">{data.tipo}</td>
                                    <td className="px-6 py-3">{data.color}</td>                                     
                                    <td className="px-6 py-3">{data.variable}</td>
                                    <td className="px-6 py-3">{data.habitacion}</td>
                                    <td className="px-6 py-3" id={data.id}>
                                        <div className="flex space-x-4">
                                            <PencilAltIcon className="h-5 w-5 fill-blue-500 cursor-pointer" aria-hidden="true" onClick={()=>{setCurrentId(data.id); setModal2(true)}}/>
                                            <TrashIcon className="h-5 w-5 fill-red-600 cursor-pointer" aria-hidden="true" onClick={()=>onDelete(data.id, 'sensores')} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}